var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createApp, defineComponent, reactive, watch } from 'vue';
import { errorRegisterUser, registerUserForm } from "../../types/front/TRegisterUserForm";
import Register from "../../models/api/v1/modal/Register";
const App = defineComponent({
    setup() {
        const STEP_1 = 1;
        const STEP_2 = 2;
        let form = reactive(registerUserForm);
        let error = reactive(errorRegisterUser);
        let registerStep = reactive({ step: STEP_1 });
        let registerStepContent = reactive({ step: STEP_1 });
        let disableSendEmailButton = reactive({ value: false });
        watch(() => registerStep, b => {
        }, { deep: true });
        watch(() => registerStepContent, b => {
        }, { deep: true });
        watch(() => disableSendEmailButton, b => {
        }, { deep: true });
        const onRegister = () => __awaiter(this, void 0, void 0, function* () {
            disableSendEmailButton.value = true;
            let response = yield Register.handleRegister({
                email: form.email,
                password: form.password,
                acceptRuleRegister: form.acceptRuleRegister
            });
            const errorResponse = response.data.errors;
            Object
                .keys(error)
                .forEach((key) => {
                if (errorResponse && errorResponse[key] && errorResponse[key][0]) {
                    // @ts-ignore
                    error[key] = errorResponse[key][0];
                }
                else {
                    // @ts-ignore
                    error[key] = '';
                }
            });
            if (response.data.success) {
                if (response.data.url) {
                    window.location.replace(response.data.url);
                }
                else {
                    registerStep.step = STEP_2;
                    registerStepContent.step = STEP_2;
                }
            }
            if (response.data.success === false) {
                alert(response.data.message);
            }
            disableSendEmailButton.value = false;
        });
        return {
            onRegister,
            form,
            error,
            registerStep,
            registerStepContent,
            disableSendEmailButton,
            STEP_1,
            STEP_2,
        };
    }
});
window.addEventListener('DOMContentLoaded', (ev) => {
    createApp(App).mount('#sign_up');
});
